import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
// 用户领取优惠券
export const addCoupon = (params) =>
  request(`${mock}/v1/coupon/addCoupon`, "get", { params });
// 用户兑换优惠券
export const addCouponByCode = (params) =>
  request(`${mock}/v1/coupon/addCouponByCode`, "get", { params });
// 优惠券详情
export const getCouponInfo = (params) =>
  request(`${mock}/v1/coupon/get`, "get", { params });
//分页获取优惠券
export const getCouponList = (params) =>
  request(`${mock}/v1/coupon/list`, "get", { params });
